import styled from 'styled-components';
const containerHeight = 4;
export const BufferedRange = styled.div.attrs(({ length, fromLeft }) => ({
    style: {
        width: `${length}%`,
        left: `${fromLeft}%`,
    },
})) `
    position: absolute;
    height: 100%;
    border-radius: ${containerHeight}px;
    background: rgba(255, 255, 255, 0.3);
`;
BufferedRange.displayName = 'BufferedRange';
//# sourceMappingURL=index.js.map